__turbopack_context__.v({
  "aboutHeroTitleGradient": "aboutHeroSection-module__fJbI0G__aboutHeroTitleGradient",
  "descriptionAnimation": "aboutHeroSection-module__fJbI0G__descriptionAnimation",
  "fadeInUp": "aboutHeroSection-module__fJbI0G__fadeInUp",
  "imageAnimation": "aboutHeroSection-module__fJbI0G__imageAnimation",
  "sectionAnimation": "aboutHeroSection-module__fJbI0G__sectionAnimation",
  "titleAnimation": "aboutHeroSection-module__fJbI0G__titleAnimation",
});
